import { createDeepEqualSelector } from 'utils/service/selectorUtils';
import { oc } from 'ts-optchain';

import * as Service from 'types/service';
import { StoreType } from '@tock/shared/utils/connect';
import { forEach } from 'es-toolkit/compat';
import { isEqual } from 'es-toolkit';

let existing: NumericDictionary<Service.ServiceTable> = {};
export const elmTablesSelector = createDeepEqualSelector(
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  (state: StoreType) => oc(state).service.app.app.tables()!,
  (tables: NumericDictionary<Service.ServiceTable>): NumericDictionary<Service.ServiceTable> => {
    if (tables && existing) {
      forEach(tables, (table) => {
        if (existing && existing[table.id] && isEqual(table, existing[table.id])) {
          tables[table.id] = existing[table.id];
        }
      });
    }
    existing = tables;
    return tables || {};
  }
);
